import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-onboarding-check",
  "use": "icon-onboarding-check-usage",
  "viewBox": "0 0 80 80",
  "content": "<symbol viewBox=\"0 0 80 80\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-onboarding-check\">\n<circle opacity=\"0.15\" cx=\"40\" cy=\"40\" r=\"40\" fill=\"#36B27E\" />\n<circle cx=\"40.0013\" cy=\"39.9994\" r=\"19.3333\" stroke=\"#36B27E\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M32 39.9993L37.3333 45.3329L48.0002 34.666\" stroke=\"#36B27E\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol